import { useContext } from 'react';

import { ApplicationFetchersContext } from './ApplicationFetchersContext';

import type { ApplicationFetchers } from './create-application-fetchers';

export const useApplicationFetchers = (): ApplicationFetchers => {
    const context = useContext(ApplicationFetchersContext);

    if (context === null) {
        throw new Error('ApplicationFetchersProvider is missing');
    }

    return context;
};
